module.exports = __webpack_public_path__ + "static/media/shape1_4.e7ae2e05.obj";